import React, { useEffect, useState, useRef } from 'react';
import { useRouter } from 'next/router';
import RoomsComponent from './RoomsComponent';
import {
  getDocs,
  collection,
  query,
  where,
  writeBatch,
  limit,
  doc,
  startAfter,
  orderBy,
} from 'firebase/firestore/lite';
import NFTsContainer from './NFTsContainer';
import PriceFilter from './PriceFilter';
import CategoryComponent from './CategoryComponent';
import CollectionComponent from './CollectionComponent';
import SearchComponent from './SearchComponent';
import { useSelector } from 'react-redux';
import { firebaseFireStore } from '../../config/firebaseFirestore';

var startAfterDoc = null;
export default function DiscoverContainer({ alpaarr }) {
  const router = useRouter();
  const searchInputEl = useRef(null);
  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);

  // const [roomDataArr, setroomDataArr] = useState([...alpaarr]);
  const [roomLoader, setRoomLoader] = useState(false);

  // useEffect(() => {

  // }, []);

  let { filter: filter, sortBy: sortBy } = router.query;

  // const getRoomsData = async () => {
  //   let dataArr = [];
  //   const roomData = await getDocs(
  //     query(
  //       collection(firebaseFireStore, 'roomDetails'),
  //       where('isActive', '==', true),
  //     ),
  //   );
  //   roomData.forEach((x) => {
  //     dataArr.push({ ...x.data(), id: x.id });
  //   });
  //   let alpaarr = dataArr.sort(function (a, b) {
  //     if (a.RoomName.toLowerCase() < b.RoomName.toLowerCase()) {
  //       return -1;
  //     }
  //     if (a.RoomName.toLowerCase() > b.RoomName.toLowerCase()) {
  //       return 1;
  //     }
  //     return 0;
  //   });

  //   setroomDataArr([...alpaarr]);
  // };

  const updateRoute = async (obj, type) => {
    let existingQueryParams = { ...router.query };

    if (type === 'remove') {
      if (existingQueryParams && existingQueryParams[obj[0]]) {
        delete existingQueryParams[obj[0]];
      }
      router.push({
        pathname: '/discover',
        query: { ...existingQueryParams },
      });
    } else if (type === 'removeFromArr') {
      console.log('remove from arr');
      if (Array.isArray(obj[1])) {
        console.log('is array');
        obj[1].map((ele, indx) => {
          existingQueryParams[obj[0]].splice(
            existingQueryParams[obj[0]].indexOf(ele),
            1,
          );
        });
      } else if (
        existingQueryParams &&
        existingQueryParams[obj[0]] &&
        existingQueryParams[obj[0]].includes(obj[1])
      ) {
        if (Array.isArray(existingQueryParams[obj[0]])) {
          existingQueryParams[obj[0]].splice(
            existingQueryParams[obj[0]].indexOf(obj[1]),
            1,
          );
        } else {
          delete existingQueryParams[obj[0]];
        }
      }
      router.push({
        pathname: '/discover',
        query: { ...existingQueryParams },
      });
    } else if (type === 'addToArr') {
      if (Array.isArray(obj[1])) {
        router.push({
          pathname: '/discover',
          query: { ...existingQueryParams, ...{ [obj[0]]: obj[1] } },
        });
      } else if (existingQueryParams && existingQueryParams[obj[0]]) {
        if (Array.isArray(existingQueryParams[obj[0]])) {
          existingQueryParams[obj[0]].push(obj[1]);
        } else {
          existingQueryParams[obj[0]] = [existingQueryParams[obj[0]], obj[1]];
        }
        router.push({
          pathname: '/discover',
          query: { ...existingQueryParams },
        });
      } else {
        router.push({
          pathname: '/discover',
          query: { ...existingQueryParams, ...{ [obj[0]]: obj[1] } },
        });
      }
    } else {
      //add new filter
      router.push({
        pathname: '/discover',
        query: { ...existingQueryParams, ...obj },
      });
    }
  };

  const reprice = async () => {
    //get all nfts
    var musicartNftsRef;
    let step = 100;

    if (startAfterDoc) {
      console.log('111111111');

      musicartNftsRef = await getDocs(
        query(
          collection(firebaseFireStore, 'musicartNfts'),
          orderBy('tokenId', 'desc'),
          startAfter(startAfterDoc),
          limit(step),
        ),
      );
    } else {
      console.log('2222222');
      musicartNftsRef = await getDocs(
        query(
          collection(firebaseFireStore, 'musicartNfts'),
          orderBy('tokenId', 'desc'),
          limit(step),
        ),
      );
    }

    let batch = writeBatch(firebaseFireStore);
    let c = [];
    musicartNftsRef.forEach((docEle) => {
      c.push(1);
      startAfterDoc = docEle;
      const data = docEle.data();
      console.log('data', data);

      let cObj = {};
      if (data.isMultiple) {
        cObj.multipleNftDetails = {};
        Object.values(data.multipleNftDetails).map((ele, indx) => {
          if (ele.nftSaleType === 'Auctioning' && ele.minBiddingPrice) {
            if (!cObj.multipleNftDetails[ele.nftId]) {
              cObj.multipleNftDetails[ele.nftId] = { ...ele };
            }
            cObj.multipleNftDetails[ele.nftId].minBiddingPrice = Number(
              (Number(ele.minBiddingPrice) * bsvRate).toFixed(2),
            );
          } else if (ele.price) {
            if (!cObj.multipleNftDetails[ele.nftId]) {
              cObj.multipleNftDetails[ele.nftId] = { ...ele };
            }
            cObj.multipleNftDetails[ele.nftId].price = Number(
              (Number(ele.price) * bsvRate).toFixed(2),
            );
          }
        });

        if (data.price) {
          cObj.price = Number((Number(data.price) * bsvRate).toFixed(2));
        }
      } else {
        if (data.nftSaleType === 'Auctioning' && data.minBiddingPrice) {
          cObj = {
            minBiddingPrice: Number(
              (Number(data.minBiddingPrice) * bsvRate).toFixed(2),
            ),
          };
        } else if (data.price) {
          cObj = {
            price: Number((Number(data.price) * bsvRate).toFixed(2)),
          };
        }
      }
      let tokenSummaryRef = doc(firebaseFireStore, 'musicartNfts', docEle.id);
      batch.update(tokenSummaryRef, cObj);
      console.log('cObj', cObj);
    });

    console.log('////////', c.length);
    // await batch.commit();
    console.log('done');
  };

  return (
    <main className="main center_container">
      <div className="container">
        {/* <button onClick={reprice}>test</button> */}
        <div className="row row--grid relative" style={{ zIndex: 2 }}>
          <div className="w-full">
            <ul className="breadcrumb">
              <li className="breadcrumb__item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb__item breadcrumb__item--active">
                Discover
              </li>
            </ul>
          </div>
        </div>

        <div className="filter__group discover_bar">
          <SearchComponent updateRoute={updateRoute} />
          <div className="main__filter-wrap discover_sortby">
            <select
              className="main__select"
              name="status"
              onChange={(event) => {
                const { value, options, selectedIndex } = event?.target;
                updateRoute({ sortBy: value });
              }}
            >
              <option
                selected={
                  !sortBy ||
                  (sortBy &&
                    sortBy !== 'popularity' &&
                    sortBy !== 'recently_created' &&
                    sortBy !== 'price_low_to_high' &&
                    sortBy !== 'price_high_to_low' &&
                    sortBy !== 'alphabetically')
                    ? true
                    : false
                }
                style={{ display: 'none' }}
                value="sort"
                disabled
                hidden
              >
                Sort by
              </option>
              <option
                selected={sortBy && sortBy === 'popularity' ? true : false}
                value="popularity"
                data-order="desc"
              >
                Popularity
              </option>
              <option
                selected={
                  sortBy && sortBy === 'recently_created' ? true : false
                }
                value="recently_created"
                data-order="desc"
              >
                Recently Created
              </option>
              <option
                selected={
                  sortBy && sortBy === 'price_low_to_high' ? true : false
                }
                value="price_low_to_high"
                data-order="asc"
              >
                Price Low to High
              </option>
              <option
                selected={
                  sortBy && sortBy === 'price_high_to_low' ? true : false
                }
                value="price_high_to_low"
                data-order="desc"
              >
                Price High to Low
              </option>
              <option
                selected={sortBy && sortBy === 'alphabetically' ? true : false}
                value="alphabetically"
                data-order="asc"
              >
                Alphabetically
              </option>
            </select>
          </div>
        </div>

        <div className="mx-auto">
          <div className="row">
            <div className="w-full discover-screen1 xl:w-2/12 lg:w-2/12 px-4">
              <div className="filter-wrap">
                <div className="filter-wrap__content">
                  <div className="filter">
                    <h4 className="filter__title">Filters&nbsp;</h4>

                    <div className="filter__group">
                      <button
                        className={`filter__btn ${
                          !filter || (filter && !filter.includes('NA-Music'))
                            ? 'filter_btn_active'
                            : ''
                        }`}
                        type="button"
                        onClick={(e) => {
                          if (filter && filter.includes('NA-Music')) {
                            if (filter && filter.includes('Artwork and More')) {
                              updateRoute(
                                ['filter', ['NA-Music', 'Artwork and More']],
                                'removeFromArr',
                              );
                            } else {
                              updateRoute(
                                ['filter', 'NA-Music'],
                                'removeFromArr',
                              );
                            }
                          } else {
                            updateRoute(['filter', 'NA-Music'], 'addToArr');
                          }
                        }}
                      >
                        Music
                      </button>
                    </div>
                    <div className="filter__group">
                      <button
                        className={`filter__btn ${
                          filter && filter.includes('Artwork and More')
                            ? 'filter_btn_active'
                            : ''
                        }`}
                        type="button"
                        onClick={(e) => {
                          if (filter && filter.includes('Artwork and More')) {
                            updateRoute(
                              ['filter', 'Artwork and More'],
                              'removeFromArr',
                            );
                          } else {
                            if (
                              !filter ||
                              (filter && !filter.includes('NA-Music'))
                            ) {
                              updateRoute(
                                ['filter', ['NA-Music', 'Artwork and More']],
                                'addToArr',
                              );
                            } else {
                              updateRoute(
                                ['filter', 'Artwork and More'],
                                'addToArr',
                              );
                            }
                          }
                        }}
                      >
                        Artwork and More
                      </button>
                    </div>
                    <div className="filter__group">
                      <button
                        className={`filter__btn ${
                          filter && filter.includes('BuyNow')
                            ? 'filter_btn_active'
                            : ''
                        }`}
                        type="button"
                        onClick={(e) => {
                          if (filter && filter.includes('BuyNow')) {
                            updateRoute(['filter', 'BuyNow'], 'removeFromArr');
                          } else {
                            updateRoute(['filter', 'BuyNow'], 'addToArr');
                          }
                        }}
                      >
                        Buy Now
                      </button>
                    </div>

                    <div className="filter__group">
                      <button
                        className={`filter__btn ${
                          filter && filter.includes('Auction')
                            ? 'filter_btn_active'
                            : ''
                        }`}
                        type="button"
                        onClick={(e) => {
                          if (filter && filter.includes('Auction')) {
                            updateRoute(['filter', 'Auction'], 'removeFromArr');
                          } else {
                            updateRoute(['filter', 'Auction'], 'addToArr');
                          }
                        }}
                      >
                        On Auction
                      </button>
                    </div>
                    <PriceFilter updateRoute={updateRoute} />

                    <RoomsComponent
                      updateRoute={updateRoute}
                      roomDataArr={alpaarr}
                    />
                    <CollectionComponent updateRoute={updateRoute} />

                    {(() => {
                      if (filter && filter.includes('NA-Music')) {
                        return <CategoryComponent updateRoute={updateRoute} />;
                      }
                    })()}
                  </div>
                </div>
              </div>
            </div>
            <NFTsContainer
              updateSearchInputEl={(val) => {
                // searchInputEl.current.value = val;
              }}
              roomDataArr={alpaarr}
              roomLoader={roomLoader}
              setRoomLoader={setRoomLoader}
              updateRoute={updateRoute}
            />
          </div>
        </div>
      </div>
    </main>
  );
}
